import { CurrencyCode, CurrencyInfo } from '@admin-panel/types';

const CurrencyData: { [key in CurrencyCode]: CurrencyInfo } = {
  [CurrencyCode.USD]: {
    code: CurrencyCode.USD,
    fullName: 'United States Dollar',
  },
  [CurrencyCode.EUR]: { code: CurrencyCode.EUR, fullName: 'Euro' },
  [CurrencyCode.GBP]: {
    code: CurrencyCode.GBP,
    fullName: 'British Pound Sterling',
  },
  [CurrencyCode.JPY]: { code: CurrencyCode.JPY, fullName: 'Japanese Yen' },
  [CurrencyCode.AUD]: { code: CurrencyCode.AUD, fullName: 'Australian Dollar' },
  [CurrencyCode.CAD]: { code: CurrencyCode.CAD, fullName: 'Canadian Dollar' },
  [CurrencyCode.CHF]: { code: CurrencyCode.CHF, fullName: 'Swiss Franc' },
  [CurrencyCode.CNY]: { code: CurrencyCode.CNY, fullName: 'Chinese Yuan' },
  [CurrencyCode.SEK]: { code: CurrencyCode.SEK, fullName: 'Swedish Krona' },
  [CurrencyCode.NZD]: {
    code: CurrencyCode.NZD,
    fullName: 'New Zealand Dollar',
  },
  [CurrencyCode.INR]: { code: CurrencyCode.INR, fullName: 'Indian Rupee' },
  [CurrencyCode.RUB]: { code: CurrencyCode.RUB, fullName: 'Russian Ruble' },
  [CurrencyCode.BRL]: { code: CurrencyCode.BRL, fullName: 'Brazilian Real' },
  [CurrencyCode.ZAR]: {
    code: CurrencyCode.ZAR,
    fullName: 'South African Rand',
  },
  [CurrencyCode.MXN]: { code: CurrencyCode.MXN, fullName: 'Mexican Peso' },
  [CurrencyCode.SGD]: { code: CurrencyCode.SGD, fullName: 'Singapore Dollar' },
  [CurrencyCode.HKD]: { code: CurrencyCode.HKD, fullName: 'Hong Kong Dollar' },
  [CurrencyCode.KRW]: { code: CurrencyCode.KRW, fullName: 'South Korean Won' },
  [CurrencyCode.TRY]: { code: CurrencyCode.TRY, fullName: 'Turkish Lira' },
  [CurrencyCode.NOK]: { code: CurrencyCode.NOK, fullName: 'Norwegian Krone' },
  [CurrencyCode.DKK]: { code: CurrencyCode.DKK, fullName: 'Danish Krone' },
  [CurrencyCode.PLN]: { code: CurrencyCode.PLN, fullName: 'Polish Zloty' },
  [CurrencyCode.THB]: { code: CurrencyCode.THB, fullName: 'Thai Baht' },
  [CurrencyCode.MYR]: { code: CurrencyCode.MYR, fullName: 'Malaysian Ringgit' },
  [CurrencyCode.IDR]: { code: CurrencyCode.IDR, fullName: 'Indonesian Rupiah' },
  [CurrencyCode.PHP]: { code: CurrencyCode.PHP, fullName: 'Philippine Peso' },
  [CurrencyCode.VND]: { code: CurrencyCode.VND, fullName: 'Vietnamese Dong' },
  [CurrencyCode.SAR]: { code: CurrencyCode.SAR, fullName: 'Saudi Riyal' },
  [CurrencyCode.AED]: {
    code: CurrencyCode.AED,
    fullName: 'United Arab Emirates Dirham',
  },
  [CurrencyCode.ILS]: { code: CurrencyCode.ILS, fullName: 'Israeli Shekel' },
  [CurrencyCode.EGP]: { code: CurrencyCode.EGP, fullName: 'Egyptian Pound' },
};

export const getCurrencyName = (currencyCode?: CurrencyCode) => {
  if (currencyCode) return CurrencyData[currencyCode].fullName + ' (' + currencyCode + ')';
  else return '';
};
